module.exports = __webpack_public_path__ + "static/img/good_default.46c590c4.png";